module.exports = __webpack_public_path__ + "img/05010013.d4571e46.jpg";